import { translate } from '@utils/i18n';
const NAMESPACE = 'inspections.visits_section';
export const t = (key, params = {}) => translate(key, Object.assign({ namespace: NAMESPACE }, params));
export const tGeneric = (key) => translate(key, { namespace: 'generic' });
